/* eslint-disable no-mixed-spaces-and-tabs */
import { API } from 'aws-amplify';

export function webinarEmoji(body)
{
	return new Promise((resolve, reject) =>
	{
		API.post('analytics', '/webinaremoji', { body })
			.then((res) =>
			{
				resolve(res);
			})
			.catch((err) =>
			{
				reject(err);
			});
	});
}

export function deviceAndLocation(body)
{
	return new Promise((resolve, reject) =>
	{
	  API.post('analytics', '/deviceandlocation', { body })
			.then((res) =>
			{
		  resolve(res);
			})
			.catch((err) =>
			{
		  reject(err);
			});
	});
}